export const SERVICE_CODE = 'MISSIONS' + '_SERVICE';
